import { Module } from '@nestjs/common';
import { EmployeeTypesController } from './employee-type.controller';
import { EmployeeTypesService } from './employee-type.service';
import { EmployeeTypes } from './employee-type.entity';
import { EmployeeTypesAdapter } from './dto/employee-type.adapter';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { TypeOrmModule } from '@nestjs/typeorm';
@Module({
  imports: [
    TypeOrmModule.forFeature([EmployeeTypes]),
  ],
  controllers: [EmployeeTypesController],
  providers: [EmployeeTypesService, EmployeeTypesAdapter, ApplicationExceptionHandler],
  exports: [EmployeeTypesService]
})
export class EmployeeTypesModule {}
